var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contest__item__wrapper" }, [
    !_vm.featuredContest.is_ad
      ? _c(
          "a",
          {
            staticClass: "contest-item",
            attrs: {
              target: "_blank",
              rel: "nofollow",
              href: _vm.getRedirectURL(_vm.featuredContest),
            },
            on: {
              click: function ($event) {
                return _vm.onContestClick(_vm.featuredContest, $event)
              },
            },
          },
          [
            _c("div", { staticClass: "contest-thumbnail" }, [
              _c("div", { staticClass: "img-box" }, [
                _c("img", {
                  staticClass: "lazy",
                  attrs: {
                    src: _vm.defaultImg,
                    "data-src": _vm.getImageUrl(),
                    alt: "",
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contest-info" }, [
              _c("div", { staticClass: "info-wrap" }, [
                _c("div", { staticClass: "contest-name" }, [
                  _c("span", { staticClass: "team" }, [
                    _vm._v(_vm._s(_vm.featuredContest.mname)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-section1" }, [
                  _c("div", { staticClass: "info-section-wrap" }, [
                    _c("div", { staticClass: "name" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.translations.currency_symbol) +
                          "\n              " +
                          _vm._s(_vm.convert_number(_vm.featuredContest.tp)) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "price-detail" }, [
                      _c("span", { staticClass: "entry-fee" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.translations.entry) +
                            "\n                " +
                            _vm._s(_vm.translations.currency_symbol) +
                            "\n                " +
                            _vm._s(_vm.convert_number(_vm.featuredContest.ef)) +
                            "\n              "
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "contest-rating" }, [
                    _c("span", { staticClass: "profit" }, [
                      _vm._v(_vm._s(_vm.translations.approx_winnings)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        class: [
                          "rating",
                          _vm.featuredContest.ar < 0
                            ? "loss"
                            : _vm.featuredContest.ar !== 0
                            ? "success"
                            : "",
                        ],
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.translations.currency_symbol) +
                            "\n              " +
                            _vm._s(_vm.convert_number(_vm.featuredContest.mp)) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-section2" }, [
                  _c("span", { staticClass: "prize-pool" }, [
                    _vm._v(
                      _vm._s(_vm.translations.top_prize) +
                        ": " +
                        _vm._s(_vm.translations.currency_symbol) +
                        "\n            " +
                        _vm._s(_vm.convert_number(_vm.featuredContest.hp))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "winning" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.getParticipantBracket(
                            _vm.featuredContest,
                            _vm.translations.contestType
                          )
                        ) +
                        "\n          "
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        )
      : _vm.checkIfAndroid()
      ? _c(
          "a",
          {
            staticClass: "contest-item img-1by1",
            on: {
              click: function ($event) {
                return _vm.captureAdClick(_vm.featuredContest)
              },
            },
          },
          [
            _c("img", {
              staticClass: "lazy",
              staticStyle: { width: "100%" },
              attrs: {
                src: _vm.defaultImg,
                "data-src": _vm.featuredContest.banner_image.replace(
                  /{{source}}/,
                  _vm.source
                ),
                alt: "",
              },
            }),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }